import {Box} from '@mui/material';
import {useQuery} from '@tanstack/react-query';
import React, {useEffect, useState} from 'react';

import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomEditableTable from '../../../components/CustomEditableTable/CustomEditableTable';
import CustomSelectField from '../../../components/CustomFormFields/CustomSelectField/CustomSelectField';
import CustomTextField from '../../../components/CustomFormFields/CustomTextField/CustomTextField';
import {
  getPartners,
  updatePartner,
  addPartner,
  getChannels,
  addChannel,
  getConfigSQL,
  updateChannel,
  getChannelMapStatus,
  addChannelMapStatus,
  updateChannelMapStatus,
  getChannelMapRejectionMsg,
  addChannelMapRejectionMsg,
  updateChannelMapRejectionMsg,
  updateConfigSQL,
  addConfigSQL,
  getQueues,
  getCronList,
  addCron,
  updateCron,
} from '../../../service/admin';

const DataGridTasks = ({taskId, setSnackBarAlert, setIsLoading}) => {
  const taskMetaData = [
    {
      id: 'partner',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.2,
        },
        {
          field: 'code',
          headerName: 'Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'app_name',
          headerName: 'App Name',
          type: 'singleSelect',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          valueOptions: ['ois', 'moss', 'pheonix', 'menu_uptime'],
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'display_name',
          headerName: 'Display Name',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'internal_name',
          headerName: 'Internal Name',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'client_auth',
          headerName: 'Client Auth',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'is_active',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
      ],
      formData: {
        column: {
          type: 'select',
          label: 'Column',
          value: 'app_name',
          options: [
            {code: 'id', label: 'Id'},
            {code: 'code', label: 'Code'},
            {code: 'app_name', label: 'App Name'},
            {code: 'internal_name', label: 'Internal Name'},
            {code: 'display_name', label: 'Display Name'},
            {code: 'is_active', label: 'Is Active'},
          ],
          error: false,
          hide: false,
          helperText: '',
        },
        value: {
          type: 'text',
          label: 'value',
          value: 'ois',
          error: false,
          hide: false,
          helperText: '',
        },
      },
      dataQueryFn: getPartners,
      addRowFn: addPartner,
      updateRowFn: updatePartner,
      addRecordMetaData: {defaultFields: {app_name: 'ois'}, fieldToFocus: 'code'},
    },
    {
      id: 'channel',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.2,
        },
        {
          field: 'code',
          headerName: 'Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'display_name',
          headerName: 'Display Name',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'internal_name',
          headerName: 'Internal Name',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'client_auth',
          headerName: 'Client Auth',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'is_group_channel',
          headerName: 'Group Channel',
          type: 'boolean',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'is_active',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
      ],
      formData: {
        column: {
          type: 'select',
          label: 'Column',
          value: 'is_active',
          options: [
            {code: 'id', label: 'Id'},
            {code: 'code', label: 'Code'},
            {code: 'internal_name', label: 'Internal Name'},
            {code: 'display_name', label: 'Display Name'},
            {code: 'is_active', label: 'Is Active'},
          ],
          error: false,
          hide: false,
          helperText: '',
        },
        value: {
          type: 'text',
          label: 'value',
          value: 'active',
          error: false,
          hide: false,
          helperText: '',
        },
      },
      dataQueryFn: getChannels,
      addRowFn: addChannel,
      updateRowFn: updateChannel,
      addRecordMetaData: {fieldToFocus: 'code'},
    },
    {
      id: 'channelStatusMapping',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.2,
        },
        {
          field: 'partner_code',
          headerName: 'Partner Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'channel_code',
          headerName: 'Channel Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'partner_status',
          headerName: 'Partner Status',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'channel_status',
          headerName: 'Channel Status',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'origin',
          headerName: 'Origin',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'is_active',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
      ],
      formData: {
        column: {
          type: 'select',
          label: 'Column',
          value: 'channel_code',
          options: [
            {code: 'id', label: 'Id'},
            {code: 'partner_code', label: 'Partner Code'},
            {code: 'channel_code', label: 'Channel Code'},
            {code: 'partner_status', label: 'Partner Status'},
            {code: 'channel_status', label: 'Channel Status'},
            {code: 'origin', label: 'Origin'},
            {code: 'is_active', label: 'Is Active'},
          ],
          error: false,
          hide: false,
          helperText: '',
        },
        value: {
          type: 'text',
          label: 'value',
          value: 'ODCH00002',
          error: false,
          hide: false,
          helperText: '',
        },
      },
      dataQueryFn: getChannelMapStatus,
      addRowFn: addChannelMapStatus,
      updateRowFn: updateChannelMapStatus,
      addRecordMetaData: {fieldToFocus: 'partner_code'},
    },
    {
      id: 'channelRejectionMsgMapping',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.2,
        },
        {
          field: 'partner_code',
          headerName: 'Partner Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'channel_code',
          headerName: 'Channel Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'partner_rejection_code',
          headerName: 'Partner Rejection Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 0.5,
        },
        {
          field: 'partner_rejection_msg',
          headerName: 'Partner Rejection Message',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'channel_rejection_code',
          headerName: 'Channel Rejection Code',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'channel_rejection_msg',
          headerName: 'Channel Rejection Message',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'is_active',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 0.5,
        },
      ],
      formData: {
        column: {
          type: 'select',
          label: 'Column',
          value: 'channel_code',
          options: [
            {code: 'id', label: 'Id'},
            {code: 'partner_code', label: 'Partner Code'},
            {code: 'channel_code', label: 'Channel Code'},
            {code: 'partner_rejection_code', label: 'Partner Rejection Code'},
            {code: 'partner_rejection_msg', label: 'Partner Rejection Message'},
            {code: 'channel_rejection_code', label: 'Channel Rejection Code'},
            {code: 'channel_rejection_msg', label: 'Channel Rejection Msg'},
            {code: 'is_active', label: 'Is Active'},
          ],
          error: false,
          hide: false,
          helperText: '',
        },
        value: {
          type: 'text',
          label: 'value',
          value: 'ODCH00002',
          error: false,
          hide: false,
          helperText: '',
        },
      },
      dataQueryFn: getChannelMapRejectionMsg,
      addRowFn: addChannelMapRejectionMsg,
      updateRowFn: updateChannelMapRejectionMsg,
      addRecordMetaData: {fieldToFocus: 'partner_code'},
    },
    {
      id: 'editConfigSQL',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.5,
        },
        {
          field: 'app_name',
          headerName: 'App Name',
          type: 'singleSelect',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          valueOptions: ['ois', 'moss', 'menu_uptime'],
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'env',
          headerName: 'Environment',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 0.5,
        },
        {
          field: 'name',
          headerName: 'Name',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'value',
          headerName: 'Value',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'is_active',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 0.5,
        },
      ],
      formData: {
        column: {
          type: 'select',
          label: 'Column',
          value: 'id',
          options: [
            {code: 'id', label: 'Id'},
            {code: 'name', label: 'Name'},
            {code: 'value', label: 'Value'},
          ],
          error: false,
          hide: false,
          helperText: '',
        },
        value: {
          type: 'text',
          label: 'value',
          value: '1',
          error: false,
          hide: false,
          helperText: '',
        },
      },
      dataQueryFn: getConfigSQL,
      addRowFn: addConfigSQL,
      updateRowFn: updateConfigSQL,
      addRecordMetaData: {defaultFields: {app_name: 'ois'}, fieldToFocus: 'name'},
    },
    {
      id: 'flushQueues',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.2,
        },
        {
          field: 'name',
          headerName: 'Queue',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: false,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'is_active',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 0.5,
        },
      ],
      dataQueryFn: getQueues,
      addRowFn: null,
      updateRowFn: updateConfigSQL,
    },
    {
      id: 'cron',
      columns: [
        {
          field: 'id',
          headerName: 'Id',
          editable: false,
          headerClassName: 'header-bg',
          flex: 0.2,
        },
        {
          field: 'cronName',
          headerName: 'Name',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'cronTime',
          headerName: 'Time',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'status',
          headerName: 'IsActive',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'cronUrl',
          headerName: 'Url',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'cronMethod',
          headerName: 'Method',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
        {
          field: 'cronHeaders',
          headerName: 'Headers',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'cronBody',
          headerName: 'Body',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 2,
        },
        {
          field: 'env',
          headerName: 'env',
          type: 'text',
          align: 'left',
          headerAlign: 'left',
          editable: true,
          headerClassName: 'header-bg',
          flex: 1,
        },
      ],
      formData: {
        column: {
          type: 'select',
          label: 'Column',
          value: 'environment',
          options: [{code: 'environment', label: 'Environment'}],
          error: false,
          hide: false,
          helperText: '',
        },
        value: {
          type: 'select',
          label: 'value',
          value: process.env.REACT_APP_ENV,
          options: [
            {code: 'production', label: 'Production'},
            {code: 'dr', label: 'DR'},
            {code: 'dev', label: 'Dev'},
            {code: 'development', label: 'Development'},
            {code: 'qa', label: 'QA'},
          ],
          error: false,
          hide: false,
          helperText: '',
        },
      },
      dataQueryFn: getCronList,
      addRowFn: addCron,
      updateRowFn: updateCron,
      addRecordMetaData: {defaultFields: {env: 'production'}, fieldToFocus: 'cronName'},
    },
  ];
  const currTaskMetaData = taskMetaData.filter((task) => task.id === taskId)?.[0];
  const [selectedTaskMetaData, setSelectedTaskMetaData] = useState(currTaskMetaData || {});

  const dataQuery = useQuery({
    queryKey: [`data-${selectedTaskMetaData?.taskName}`],
    queryFn: () => selectedTaskMetaData.dataQueryFn(selectedTaskMetaData?.formData),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const handleFormChange = (e) => {
    setSelectedTaskMetaData((prevSelectedTaskMetaData) => {
      const updatedFormData = {
        ...prevSelectedTaskMetaData.formData,
        [e.target.id]: {
          ...prevSelectedTaskMetaData.formData[e.target.id],
          value: e.target.value,
          error: false,
          helperText: '',
        },
      };
      return {
        ...prevSelectedTaskMetaData,
        formData: updatedFormData,
      };
    });
  };

  const handleFetchClick = () => {
    if (!selectedTaskMetaData?.formData?.column?.value) {
      return setSelectedTaskMetaData((prevSelectedTaskMetaData) => {
        const updatedFormData = {
          ...prevSelectedTaskMetaData.formData,
          column: {
            ...prevSelectedTaskMetaData.formData.column,
            error: true,
            helperText: 'required',
          },
        };
        return {
          ...prevSelectedTaskMetaData,
          formData: updatedFormData,
        };
      });
    } else if (!selectedTaskMetaData?.formData?.value?.value) {
      return setSelectedTaskMetaData((prevSelectedTaskMetaData) => {
        const updatedFormData = {
          ...prevSelectedTaskMetaData.formData,
          value: {
            ...prevSelectedTaskMetaData.formData.value,
            error: true,
            helperText: 'required',
          },
        };
        return {
          ...prevSelectedTaskMetaData,
          formData: updatedFormData,
        };
      });
    }
    dataQuery.refetch();
  };

  useEffect(() => {
    if (dataQuery?.isLoading || dataQuery?.isFetching) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [dataQuery?.isLoading, dataQuery?.isFetching]);

  return (
    <>
      <Box sx={{p: 1, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        {selectedTaskMetaData?.formData && (
          <>
            {Object.keys(selectedTaskMetaData?.formData).map((key, index) => {
              const fieldData = selectedTaskMetaData?.formData[key];
              if (!fieldData.hide && fieldData.type === 'text') {
                return (
                  <CustomTextField
                    key={key}
                    label={fieldData.label}
                    id={key}
                    disabled={fieldData.disabled}
                    value={fieldData?.value}
                    onChange={handleFormChange}
                    error={fieldData?.error}
                    helperText={fieldData.helperText || ''}
                    minWidth={500}
                  />
                );
              }
              if (!fieldData.hide && fieldData.type === 'select') {
                return (
                  <CustomSelectField
                    key={key}
                    id={key}
                    label={fieldData.label}
                    disabled={fieldData.disabled}
                    options={fieldData.options}
                    value={fieldData?.value}
                    onChange={handleFormChange}
                    error={fieldData?.error}
                    helperText={fieldData.helperText || ''}
                  />
                );
              }
              return null;
            })}
            <CustomButton
              text={'Fetch'}
              size="large"
              onClick={handleFetchClick}
              isLoading={dataQuery?.isLoading || dataQuery?.isFetching}
            />
          </>
        )}
      </Box>
      <Box>
        <CustomEditableTable
          addRowFn={selectedTaskMetaData?.addRowFn}
          updateRowFn={selectedTaskMetaData?.updateRowFn}
          columns={selectedTaskMetaData?.columns || []}
          initialRows={dataQuery?.data?.rows}
          addRecordMetaData={selectedTaskMetaData?.addRecordMetaData}
          setSnackBarAlert={setSnackBarAlert}
        />
      </Box>
    </>
  );
};

export default DataGridTasks;
